// TODO: Add image alt tag.
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Row, Col, Tab, Nav } from 'react-bootstrap';
import NavLink from '@root/components/NavLink';
import TabPane from '@root/components/TabPane';
import { useState, ReactNode, useMemo } from 'react';
import { PageComponent } from '@root/pages/Type';
import Lottie from 'react-lottie';
import styles from './ControlPanelSection.module.scss';

type Item = {
    id: string;
    title: ReactNode;
    description: ReactNode;
    icon: string;
    content: any;
    speed?: number;
};

type ControlPanelSecitionTabItemProps = {
    item: Item;
    onClickPrev: (event: React.MouseEvent<HTMLSpanElement>) => void;
    onClickNext: (event: React.MouseEvent<HTMLSpanElement>) => void;
};

const ControlPanelSecitionTabItem: PageComponent<
    ControlPanelSecitionTabItemProps
> = ({ item, onClickPrev, onClickNext }) => {
    return (
        <Nav.Item className={styles.nav_item}>
            <NavLink
                eventKey={item.id}
                className={styles.nav_link}
                activeClass={styles.active}
            >
                <span className={styles.prev} onClick={onClickPrev} />
                <span className={styles.next} onClick={onClickNext} />
                <div className={styles.control_container}>
                    <div className={styles.control_panel_icon}>
                        <img src={`/static/img/icons/${item.icon}.svg`} />
                    </div>
                    <div className={styles.control_text}>
                        <h2>{item.title}</h2>
                        <p>{item.description}</p>
                    </div>
                </div>
            </NavLink>
        </Nav.Item>
    );
};

type ControlPanelSecitionTabContentProps = {
    item: Item;
};

const ControlPanelSecitionTabContent: PageComponent<
    ControlPanelSecitionTabContentProps
> = ({ item }) => {
    const defaultOptions = useMemo(
        () => ({
            loop: true,
            autoplay: true,
            animationData: item.content,
            rendererSettings: {
                preserveAspectRatio: 'xMidYMid slice',
            },
        }),
        [item],
    );
    return (
        <TabPane
            eventKey={item.id}
            className={styles.tab_pane}
            activeClass={styles.active}
        >
            {typeof item.content === 'string' ? (
                <img src={item.content} />
            ) : (
                <Lottie
                    options={defaultOptions}
                    height={400}
                    width={400}
                    isStopped={false}
                    isPaused={false}
                    speed={item.speed || 1}
                    isClickToPauseDisabled
                />
            )}
        </TabPane>
    );
};

type ControlPanelSectionProps = {
    items: Item[];
    title: ReactNode;
    description: ReactNode;
};

const ControlPanelSection: PageComponent<ControlPanelSectionProps> = ({
    items,
    title,
    description,
}) => {
    const [activeKey, setActiveKey] = useState<string>('0');

    const handleSelect = (key: string | null) => {
        if (key) setActiveKey(key);
        // if (key) console.log(`handleSelect ${key}`);
    };
    const onClickNext = (event: React.MouseEvent<HTMLSpanElement>) => {
        event.preventDefault();
        event.stopPropagation();
        let nextKey: number = parseInt(activeKey, 10) + 1;
        if (nextKey > 2) {
            nextKey = 0;
        }
        // console.log(`next ${nextKey.toString()}`);
        setActiveKey(nextKey.toString());
    };
    const onClickPrev = (event: React.MouseEvent<HTMLSpanElement>) => {
        event.preventDefault();
        event.stopPropagation();
        let nextKey: number = parseInt(activeKey, 10) - 1;
        if (nextKey < 0) {
            nextKey = 2;
        }
        // console.log(`prev ${nextKey.toString()}`);
        setActiveKey(nextKey.toString());
    };

    return (
        <section className={`${styles.section} container`}>
            <h1 className={styles.title}>{title}</h1>
            <p className={styles.desc}>{description}</p>

            <Tab.Container
                activeKey={activeKey}
                onSelect={handleSelect}
                id="control-panel-context"
            >
                <Row className={styles.row}>
                    <Col
                        lg={5}
                        md={8}
                        sm={8}
                        className="mx-auto ml-md-auto mx-sm-auto mx-lg-0"
                    >
                        <Nav
                            variant="pills"
                            role="tablist"
                            as="nav"
                            className={`flex-column ${styles.nav_pills}`}
                        >
                            {items.map((item) => (
                                <ControlPanelSecitionTabItem
                                    key={item.id}
                                    item={item}
                                    onClickPrev={onClickPrev}
                                    onClickNext={onClickNext}
                                />
                            ))}
                        </Nav>
                    </Col>
                    <Col sm={7} className="d-none d-lg-block p-0">
                        <Tab.Content className={styles.tab_content}>
                            {items.map((item) => (
                                <ControlPanelSecitionTabContent
                                    key={item.id}
                                    item={item}
                                />
                            ))}
                        </Tab.Content>
                    </Col>
                </Row>
            </Tab.Container>
        </section>
    );
};

export default ControlPanelSection;
